import React, { useState } from "react";
import { Barcode, Sparkles, Send, CheckCircle2, Wand2 } from "lucide-react";
import Create from "./Create";
import Fresh from "./Fresh";
import Sent from "./Sent";
import Assigned from "./Assigned";

type Tab = "create" | "fresh" | "sent" | "assigned";

type TabDef = {
  id: Tab;
  label: string;
  icon: React.ReactNode;
  description: string;
};

const TABS: TabDef[] = [
  {
    id: "create",
    label: "Create",
    icon: <Wand2 className="h-4 w-4" />,
    description: "Generate new gift codes",
  },
  {
    id: "fresh",
    label: "Fresh",
    icon: <Sparkles className="h-4 w-4" />,
    description: "Generated, not yet sent",
  },
  {
    id: "sent",
    label: "Sent",
    icon: <Send className="h-4 w-4" />,
    description: "Already delivered to recipients",
  },
  {
    id: "assigned",
    label: "Assigned",
    icon: <CheckCircle2 className="h-4 w-4" />,
    description: "Redeemed by a registration",
  },
];

export default function GiftCodeCreation() {
  const [currentTab, setCurrentTab] = useState<Tab>("create");
  const active = TABS.find((t) => t.id === currentTab)!;

  return (
    <div className="dark min-h-screen bg-slate-950 text-slate-100">
      <div className="mx-auto max-w-[1400px] px-4 py-5 space-y-4">
        <header className="flex items-baseline justify-between flex-wrap gap-2">
          <h1 className="text-lg font-bold flex items-center gap-2">
            <Barcode className="h-5 w-5 text-blue-400" />
            Gift Codes
          </h1>
          <span className="text-xs text-slate-400">{active.description}</span>
        </header>

        <div className="inline-flex p-1 rounded-xl border border-slate-700/40 bg-slate-800/40 gap-1">
          {TABS.map((tab) => {
            const isActive = currentTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setCurrentTab(tab.id)}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                  isActive
                    ? "bg-blue-500/20 text-blue-200 border border-blue-500/40"
                    : "text-slate-300 border border-transparent hover:bg-slate-700/40 hover:text-slate-100"
                }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            );
          })}
        </div>

        <div>
          {currentTab === "create" && <Create />}
          {currentTab === "fresh" && <Fresh />}
          {currentTab === "sent" && <Sent />}
          {currentTab === "assigned" && <Assigned />}
        </div>
      </div>
    </div>
  );
}
